export const cart = (state) => {
    return state.cart
}
export const order = (state) => {
    return state.order
}